<template>
  <v-container>
    <v-card>
      <v-card-text>
        <h2 class="text-center">Qu'est-ce que R'Cog et qui sommes-nous ?</h2>
        <br />
        <hr />
        <br />
        <p>
          R’Cog est une plateforme en ligne destinée aux
          <b>psychologues spécialisés en neuropsychologie.</b> L'objectif est de
          proposer une
          <b>bibliothèque de ressources en intervention cognitive</b> fondée sur
          des preuves scientifiques.
        </p>
        <br />
        <p>
          Cette plateforme est issue de la collaboration entre deux frères
          travaillant dans des domaines complémentaires :
        </p>
        <ul>
          <li>
            <b>Anthony Deleplace</b>, psychologue spécialisé en neuropsychologie
            de l'enfant et de l'adolescent.
          </li>
          <li><b>Nicolas Deleplace</b>, ingénieur en informatique médical.</li>
        </ul>
        <br />
        <p>
          À travers cette plateforme nous souhaitons
          <b>inciter l'utilisation d'une démarche d'Evidence Based Practice</b>
          (EBP) en préconisant des interventions cognitives fondées sur des
          preuves scientifiquement établies. Cette plateforme reste évolutive et
          pourra être modifiée régulièrement dans le but de toujours faciliter
          son utilisation et de répondre aux perpétuels changements des critères
          scientifiques.
        </p>
        <br />
        <p>
          R'Cog se veut <b>collaboratif</b> de sorte à ce que tout praticien
          inscrit puisse y ajouter des activités inspirées d'articles aux bases
          théoriques et scientifiques solides. Pour autant, chaque utilisateur
          est encouragé à <b>faire ses propres recherches</b> et à
          <b>rester critique</b> vis-à-vis des activités proposées. Il ne s'agit
          en aucun cas d'appliquer stricto sensu les activités proposées mais de
          s'en inspirer pour pouvoir les adapter à chaque réalité clinique
          unique.
        </p>
        <br />
        <p>Nous vous souhaitons une bonne utilisation !</p>
        <br />
        <p>Anthony & Nicolas</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "AboutUs"
};
</script>
